import React, { useEffect } from 'react';
import { notification } from 'antd';
import { setNotifyFunction } from './notify'; // make sure path is correct

const NotificationProvider = ({ children }) => {
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    setNotifyFunction(({ type = 'info', title, message }) => {
      api[type]({
        message: title,
        description: message,
      });
    });
  }, [api]);

  return (
    <>
      {contextHolder}
      {children}
    </>
  );
};

export default NotificationProvider;
